import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskTicketFieldContent } from 'src/app/interfaces/zendesk-ticket-field-content';

import { BaseModel } from './base-model';
import { ZendeskTicket } from './zendesk-ticket';

export class ZendeskTicketField extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskTicketFieldProperties: (
    | {
        property: keyof ZendeskTicketField;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskTicketField;
        type: 'alias';
      }
    | {
        property: keyof ZendeskTicketField;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ZendeskTicketFieldId', type: 'column', dataType: 'number' },
    { property: 'ticketFieldContentJSON', type: 'column', dataType: 'JSON' },
    { property: 'active', type: 'column', dataType: 'boolean' },
    { property: 'title', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ZendeskTicketField.ZendeskTicketFieldProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          ZendeskTicketField.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          ZendeskTicketField.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          ZendeskTicketField.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(ZendeskTicketFieldObject: Partial<ZendeskTicketField>) {
    super();

    ZendeskTicketField.ZendeskTicketFieldProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = ZendeskTicketFieldObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  ZendeskTicketFieldId?: number;
  ticketFieldContentJSON?: ZendeskTicketFieldContent;
  active?: boolean;
  title?: string;
  createdAt?: Date;
  updatedAt?: Date;

  ZendeskTicket?: ZendeskTicket;
}
